import {createTableState, normalizePagination} from '@/core/services/Helper'

const state = () => ({
    save: {},
    table: createTableState(),
    filterData: undefined
})

// getters
const getters = {}

// actions
const actions = {
    // get records
    async get({state, commit, rootState}, {warehouseId} = {}) {
        commit('setLoading', true)
        commit('updateTableData', [])

        const res = await this._vm.axios.get(this._vm.endpoints['company_stock_warehouse_shelf'], {
            urlVars: { warehouseId }
        })

        const {data, meta} = res.data
        commit('updateTableData', data)
        commit('updatePagination', normalizePagination(meta))

        setTimeout(() => {
            commit('setLoading', false)
        }, 250)
    },

    //  show record
    async show({commit, dispatch, rootState}, {warehouseId, id}) {
        commit('setLoading', true)
        commit('updateSaveData', {})

        const res = await this._vm.axios.get(this._vm.endpoints['company_stock_warehouse_shelf'] + '/' + id, {
            urlVars: { warehouseId }
        });
        if (res.status) {
            const {data} = res.data
            commit('updateSaveData', data)
        } else {
            this._vm.$message.error(res.message)
        }

        commit('setLoading', false)
    },

    //  show record
    async add({commit, dispatch, rootState}, {formData, warehouseId}) {
        commit('setLoading', true)

        try {
            const res = await this._vm.axios.post(
                this._vm.endpoints['company_stock_warehouse_shelf'],
                formData,
                { urlVars: { warehouseId } }
            )

            return res.data
        } catch (error) {
            this._vm.onResponseFailure(error.response.data);
        } finally {
            commit('setLoading', false)
        }
    },

    // update record
    async update({commit, dispatch, rootState}, {formData, warehouseId, id}) {
        commit('setLoading', true)

        try {
            const res = await this._vm.axios.put(
                this._vm.endpoints['company_stock_warehouse_shelf'] + '/' + id,
                formData,
                { urlVars: { warehouseId } }
            )

            return res.data
        } catch (error) {
            this._vm.onResponseFailure(error.response.data);
        } finally {
            commit('setLoading', false)
        }
    },

    //  delete record
    async delete({commit, dispatch, rootState}, {warehouseId, id}) {
        let successDeleted = [];
        if (id.length === 0) {
            this._vm.$message.warning(this._vm.$t('messages.selectRow'))
        } else {
            for (let i = 0; i < id.length; i++) {
                const {data} = await this._vm.axios.delete(this._vm.endpoints['company_stock_warehouse_shelf'] + '/' + id[i], {
                    urlVars: { warehouseId }
                });
                if (data.status) {
                    this._vm.$message.success(this._vm.$t('messages.deleteOk'));
                    successDeleted.push(id[i]);
                } else {
                    this._vm.$message.error(data.message)
                }
            }

            dispatch('refresh')

            return successDeleted;
        }
    },

    // refresh records
    refresh({dispatch}) {
        dispatch('get');
    }
}

// mutations
const mutations = {
    setLoading(state, val) {
        state.table.loading = val
    },
    updateTableData(state, data) {
        state.table.data = data
    },
    updatePagination(state, pagination) {
        state.table.pagination = pagination
    },
    updateSaveData(state, data) {
        state.save.data = data
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
}
